import { getters } from "@/constants/state";

export default {
  [getters.ROOSTER_FORECAST_GETTER]: (state) => state.roosterForecast,
};
